import { render } from "./UserSelect.vue?vue&type=template&id=054ec8c4&scoped=true"
import script from "./UserSelect.vue?vue&type=script&lang=js"
export * from "./UserSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054ec8c4"]])

export default __exports__